export const CountryReducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_COUNTRIES':
      return {
        ...state,
        countries: action.countries,
      };
    case 'SELECT_COUNTRY':
      return {
        ...state,
        selectedCountry: action.selectedCountry,
      };
    default:
      return {
        ...state,
      };
  }
};
